$eve_app_page_components_flex $eve_app_page_sb_page
	title \Flex
	body /
		<= Playground $eve_app_page_sb_playground
			component_name \Live_flex
			default_source \
				\Live_flex $eve_flex
				\	- Edit values of Flex component
				\	justify_content \center
				\	align_items \center
				\	- TODO: узнать как стилизовать .view.css.ts для этого компонента
				\	style *
				\		width \30%
				\		height \30%
				\		position \relative
				\	wrap \wrap
				\	sub /
				\		<= Demo_item $eve_surface
				\			colors \medium
				\			style *
				\				width \10%
				\				height \10%
				\				position \absolute
				\
	Showcase_cell* $eve_surface
		colors \lowest
